/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import quickFetch from 'quick-fetch';
import EarlyRequestLogger from './earlyRequestLogger';
const getFromEarlyRequest = (requestKey, fallback, _options = {}) => {
  let earlyRequest = null;
  earlyRequest = quickFetch.getRequestStateByName(requestKey);
  const options = Object.assign({
    alias: requestKey,
    useEarlyRequest: r => !!r,
    onEarlyRequestFinish: d => d
  }, _options);
  const logger = new EarlyRequestLogger(options.alias);
  logger.start();
  logger.info('useEarlyRequest', options.useEarlyRequest(earlyRequest));
  if (options.useEarlyRequest(earlyRequest)) {
    return new Promise((resolve, reject) => {
      if (!earlyRequest) {
        logger.end('error (earlyRequest is null)');
        return;
      }
      earlyRequest.whenFinished(data => {
        logger.end('success');
        setTimeout(() => quickFetch.removeEarlyRequest(requestKey));
        return resolve(options.onEarlyRequestFinish(data));
      });
      earlyRequest.onError(() => {
        return fallback().then(resolve, reject).then(() => logger.end('error'));
      });
    });
  }
  return new Promise((resolve, reject) => {
    return fallback().then(resolve, reject).then(() => logger.end('fallback'));
  });
};
export default getFromEarlyRequest;